import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHandshake, faBox, faGifts, faShieldVirus } from "@fortawesome/free-solid-svg-icons"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Cover from '../components/cover/cover'
import ContactForm from '../components/form/form'
import Testimonials from '../components/testimonials/testimonials'
import SplitView from '../components/splitview/splitview'
import SlideShow from "../components/slideshow/slideshow"

// image imports
import cover from "../images/home-cover-alt.jpg"
import boxImage from "../images/car.png"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    {/* <Cover
      image={cover}
      title={`We Clothe Them`}
      paragraph={`It is an attempt to gift comfort, warmth, protection, hygiene and hope. We Clothe Them because together we can.`}
      button={``}
    /> */}
    <section className={`color sm`}>
      <div className={`background`}>
        <StaticImage src={`../images/home-cover.png`} width={2400} />
      </div>
      <div className={`content`}>
        <div className={`title-wrapper`}>
        <div className={`title`}>
          <div>
            <h1>We Clothe Them</h1>
            <p>It is an attempt to gift comfort, warmth, protection, hygiene and hope.</p>
            <p><span className={`highlight`}>We Clothe Them</span> because together we can.</p>
            <Link to="/about"><button>Learn More</button></Link>
          </div>
          </div>
          <div className={`split-alt slideshow`}>
            <SlideShow n={3}>
            </SlideShow>
          </div>          
        </div>
        <div className={`news`}>
          <p>Read about safety and precautions at We Clothe Them for Covid-19</p>
          <Link to="/covid"><button>Learn more</button></Link>
        </div>
      </div>
    </section>
    <section className={`dark sm`}>
      <div className={`content`}>
        <h6 className={`letter-spaced-heading center`}>Our Efforts</h6>
        <h2 className={`center`}>What we've done so far</h2>
        <div className={`split-wrapper-alt`}>
          <div className={`split-alt`}>
          <div className={`map-wrapper`}>
            <div className={`map`}>
              <StaticImage src={`../images/Map Main.png`} width={1000} />
            </div>
          </div>
          </div>
          <div className={`split-alt`}>
          <div
            className={`flex margins`}
            style={{ justifyContent: `center`, flexWrap: `wrap` }}
          >
            <div className={`stat-tile`}>
                <h1>2</h1>
                <p>Countries</p>
            </div>
            <div className={`stat-tile`}>
                <h1>4</h1>
                <p>Cities</p>
            </div>
            <div className={`stat-tile`}>
                <h1>50+</h1>
                <p>Drives</p>
            </div>
            <div className={`stat-tile`}>
                <h1>7,000+</h1>
                <p>People Clothed</p>
            </div>
          </div>
          </div>
        </div>
      </div>
    </section>
    
    <section style={{ padding: `0` }}>
      <div className={`flex card-wrapper`}>
        <div className={`card`}>
          <div className={`content-md`}>
          <div className={`photo-wrap`}>
            <StaticImage src={'../images/car.png'} width={800} />
          </div>
          <div className={`icon`} style={{ fontSize: `2.25em`, margin: `2vh 0` }}>
            <FontAwesomeIcon icon={faHandshake} />
          </div>
          <h5 className={`letter-spaced-heading`}>Collaborations</h5>
          <h3>Partnering with Organisations</h3>
          <p>Partner with us to complement our expertise and capabilities and achieve the common goal of helping those in need! WCT welcomes you to collaborate and be a part of our mission to provide the joy of warmth of clothing to those in need.</p>      
          <Link to='/collaborate'>
            <button style={{ position: `absolute`, bottom: `5vw` }}>
              Collaborate
            </button>
          </Link>
        </div>
      </div>
      <div className={`card`}>
          <div className={`content-md`}>
          <div className={`photo-wrap`}>
            <StaticImage src={'../images/about-cover.jpg'} width={800} />
          </div>
          <div className={`icon`} style={{ fontSize: `2.25em`, margin: `2vh 0` }}>
            <FontAwesomeIcon icon={faBox} />
          </div>
          <h5 className={`letter-spaced-heading`}>Collection</h5>
          <h3>Clothes Collection Drives</h3>
          <p>Got a t-shirt that you don’t like wearing anymore or that pair of jeans that you’ve outgrown? Let us help you by putting them to right use! Write to us for collection and we’ll make sure that your donations are collected to reach their end users safely.</p>      
          <Link to='/collaborate'>
            <button style={{ position: `absolute`, bottom: `5vw` }}>
              Reach Out
            </button>
          </Link>
        </div>
      </div>
      <div className={`card`}>
          <div className={`content-md`}>
          <div className={`photo-wrap`}>
            <StaticImage src={'../images/home-cover.jpg'} width={800} />
          </div>
          <div className={`icon`} style={{ fontSize: `2.25em`, margin: `2vh 0` }}>
            <FontAwesomeIcon icon={faGifts} />
          </div>
          <h5 className={`letter-spaced-heading`}>Donation</h5>
          <h3>Helping through Donation Drives</h3>
          <p>Become a part of our pursuit to spread happiness and joy among those who need support and for each of us to experience the joy of giving. Contact us to contribute your bit to help us find the right donors.</p>      
          <Link to='/collaborate'>
            <button style={{ position: `absolute`, bottom: `5vw` }}>
              Volunteer
            </button>
          </Link>
        </div>
      </div>
      </div>
    </section>

    <section className={`dark sm`}>
      <div className={`content-md`}>
        <h6 className={`letter-spaced-heading center`}>What We Do</h6>
        <h2 className={`center`}>About the Initiative</h2>
        <div className={`video-embed`}>
          <iframe
            class="video"
            width="1519"
            height="550"
            src="https://www.youtube.com/embed/M-v1FV5Wlxs"
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </div>
        <p className={`center`}>
          We Clothe Them is an NGO seeking to empower the less privileged by
          giving them access to one of the basic needs of survival - clothing.
          It is an endeavor to bridge the unequal distribution of resources by
          collecting surplus clothes from the more privileged sections of
          society and directing them to people who really need them through
          collaborations with universities, corporates and localized collection
          drives.
        </p>
        <div className={`button-group center`}>
          <Link to='/donations'><button>Our Impact</button></Link>
        </div>
      </div>
    </section>
    
    <SplitView image={boxImage} wrapStyle={`reverse`} splitStyle={`grey`}>
      <h6 className={`letter-spaced-heading`}>Collaborate</h6>
      <h2>Let's make a difference</h2>
      <p>
        We Clothe Them encourages collaborations with <span className={`highlight`}>universities, corporates,
        organisations, social service societies and other non-profits</span>. We have
        so far collaborated with the Rotaract Society of Delhi Technological
        University, Medina of Kirori Mal College, National Social Service Scheme
        of Jesus and Mary College and Shyama Prasad Mukherji College, SRCC,
        NSIT, IIT Bombay and Writers Victoria, Melbourne.
      </p>
      <p>
        If you resonate with our mission and approach of ensuring clothing for
        all and can aid us in our endeavour of creating greater positive change,
        write to us at <a href={`mailto:weclothethem@gmail.com`}>weclothethem@gmail.com</a>.
      </p>
      <Link to='/collaborations'><button>Our Collaborations</button></Link>
    </SplitView>
    <section className={`sm`}>
      <div className={`content-md`}>
        <h6 className={`letter-spaced-heading`}>Safety & Precuations</h6>
        <h2><span className={`secondary`}><FontAwesomeIcon icon={faShieldVirus} /></span> Covid-19 Measures</h2>
        <p>With the pandemic changing the way we live our lives, we need to be cautious of the safety of both our donors and donees. With immense precautions for both collection and donation of clothes, we have been taking up the following measures:</p>
        <ul>
          <li>Complete sanitization and washing of clothes during collection.</li>
          <li>Recyclable packaging of clothes for donation.</li>
          <li>Tagging of clothes by gender and size to promote least contact.</li>
        </ul>
        <Link to="/covid"><button>Learn More</button></Link>
      </div>
    </section>
    {/* <section className={`grey sm`}>
      <div className={`content-md`}>
        <h6 className={`letter-spaced-heading center`}>Testimonials</h6>
        <h2 className={`center`}>Collaboration Stories</h2>
        <Testimonials />
      </div>
    </section> */}
    {/* <section className={`sm`}>
      <div className={`content-sm`}>
        <h6 className={`letter-spaced-heading center`}>Contact</h6>
        <h2 className={`center`}>Write to Us</h2>
        <ContactForm />
      </div>
    </section> */}
  </Layout>
)

export default IndexPage
